import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
// VitaCallout import removed while Vita is hidden — code kept in src/components/Vita.tsx

export function BioAbsorbExplainer() {
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-6 overflow-hidden rounded-2xl border border-border bg-card">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left transition-colors hover:bg-muted/30"
        aria-expanded={open}
      >
        <span className="text-sm font-semibold text-brand-deep">
          Powered by <span className="text-brand">Bio-Absorb Matrix</span>
        </span>
        <motion.span
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className="flex-shrink-0"
        >
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        </motion.span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <div className="px-5 pb-5 pt-1">
              <div className="mb-4">
                <h3 className="font-display text-xl font-bold text-brand-deep">
                  Bio-Absorb Matrix
                </h3>
                <p className="mt-1 text-sm text-muted-foreground">
                  Our proprietary delivery support blend
                </p>
              </div>

              <div className="space-y-3 text-sm leading-relaxed text-foreground/80">
                <p>
                  A proprietary phytonutrient blend formulated to support absorption of the active ingredients in every TruWe formula.
                </p>
                <p>
                  It is paired with liposomal carriers and chelated minerals delivery forms with published bioavailability data to help your body use what is on the label.
                </p>
                <p className="text-muted-foreground">
                  The exact composition of Bio-Absorb Matrix is proprietary.
                </p>
              </div>

              <div className="mt-4">
                {/* Vita hidden for now — re-add with the launcher: <VitaCallout>Ask Vita how Bio-Absorb Matrix works</VitaCallout> */}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
